import clsx from "clsx";
import { useContext, useEffect, useState } from "react";
import FiberCompanyApi from "../../../../API/FiberCompanyApi";
import FiberCompanyListSkeleton from "./skeletons/FiberCompanyListSkeleton";
import { UserContext } from "../../../../App";

const FiberCompanyList = ({ selected, setSelected }) => {
	const [data, setData] = useState();
	const [loading, setLoading] = useState(true);
	const user = useContext(UserContext);

	useEffect(() => {
		FiberCompanyApi.SearchFiberCompany({
			pagingParams: { pageNumber: 1, pageSize: 100 },
			salesRepId: user.userType === "SalesRep" ? user.id : undefined,
			salesOrgId: user.userType === "SalesRep" ? user.salesOrgId : undefined,
		})
			.then((res) => {
				if (res.status.success) {
					const fiberCompanies = res.data.list;

					fiberCompanies.sort((a) => (a.active ? -1 : 1));

					setData(fiberCompanies);
					setLoading(false);
				}
			})
			.catch((err) => {
				console.error(err);
			});
	}, []);

	if (loading) return <FiberCompanyListSkeleton />;

	return (
		<div className="overflow-hidden ">
			<div
				className="flex gap-4 overflow-x-auto px-4 lg:px-8 pb-3"
				style={{
					scrollbarWidth: "none",
					msOverflowStyle: "none",
					"&::-webkit-scrollbar": {
						display: "none",
					},
				}}
			>
				{data.map((item) => (
					<div
						onClick={() =>
							item.id === selected ? setSelected(null) : setSelected(item.id)
						}
						key={item.id}
						className={clsx(
							"shrink-0 h-12 py-1 px-4 rounded-full border-2 border-solid transition-colors relative flex justify-center",
							selected === item.id ? "border-blue-500" : "border-gray-300",
						)}
					>
						<img
							className="object-cover h-full"
							src={"data:image/png;base64," + item.logo}
							alt={item.name}
						/>
						{!item.active && (
							<div className="bg-white px-1 text-xs border border-gray-400 text-gray-400 rounded-full absolute top-[-2px] -right-1">
								Inactive
							</div>
						)}
					</div>
				))}
			</div>
		</div>
	);
};

export default FiberCompanyList;
